import { Employee } from "../employee/employee";
import { InsuredTripPartner } from "./insured-trip-partner";

export class InsuredTripRequest {
  dateBegin: string;
  dateEnd: string;
  dateSigned: string;
  tariff: string;
  zone: string;
  premium: number;
  note: string;
  partner: Array<InsuredTripPartner> = [];
  statusId?: number;
  rate?: number;
}
